import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ParametroPerimetroDto } from '@ideapa/common-dto';

import { ApiClientConfig } from '../api-client-config';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { BaseCRUDApiClient } from '@ideapa/app-base-api-client';

@Injectable()
export class ParametroPerimetroApiClient extends BaseCRUDApiClient<ParametroPerimetroDto> {
  baseUrl = this.config.apiEndpoint + '/parametro-perimetro';

  constructor(http: HttpClient, private config: ApiClientConfig) {
    super(http);
  }
}
